import { EventHandler } from '@n7-frontend/core';
import { HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Utils } from '../data-sources/utils';
export class ExportPdfEH extends EventHandler {
  public listen() {
    this.innerEvents$.subscribe(({ type, payload }) => {
      if (!payload) { return; }
      let printUrl = environment.print_url;
      switch (type) {
        case 'export-pdf.click':
          const fileName = 'Export-'+ Utils.slug(payload.name, 3) + '.pdf';
          printUrl += 'print/' + payload.id;
          this.dataSource.waiting(true);
          payload.communication.request$('getPrint', {
            params: { pageToScreenshot: printUrl },
            onError: (error) => {
              console.error(error),
                this.dataSource.waiting(false);
            },
            httpOptions: {
              headers: new HttpHeaders({
                'Content-Type': 'application/json; charset=utf-8',
              })
            }
          }).subscribe(data => {
            const byteArray = new Uint8Array(data.buffer.data);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            if (window.navigator.msSaveBlob) { // // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
              window.navigator.msSaveOrOpenBlob(blob, fileName);
            } else {
              const link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = fileName;
              link.click();
            }
            this.dataSource.waiting(false);
          });
          break;
        default:
          break;
      }
    });
  }
}
